import { Breakpoints } from './types';

/**
 * Based on Tailwind CSS Responsive design
 * @see https://tailwindcss.com/docs/responsive-design
 */
export const breakpoints: Breakpoints = {
  sm: '640px',
  md: '760px',
  lg: '1024px',
  xl: '1280px',
};

// @deprecated
export const mediaMobile = `@media screen and (max-width: ${breakpoints.md})`;

// Responsive first breakpoints
export const mediaDesktop = `@media screen and (min-width: ${breakpoints.md})`;
export const mediaSm = `@media screen and (min-width: ${breakpoints.sm})`;
export const mediaMd = `@media screen and (min-width: ${breakpoints.md})`;
export const mediaLg = `@media screen and (min-width: ${breakpoints.lg})`;
export const mediaXl = `@media screen and (min-width: ${breakpoints.xl})`;
